import { api } from './api'

export interface Profile {
  id: string
  full_name: string
  avatar_url?: string | null
  job_title?: string | null
  phone?: string | null
  onboarding_completed: boolean
  active_organization_id?: string | null
}

export interface OrganizationMembership {
  organization_id: string
  role: string
  status: string
  organizations?: {
    id: string
    name: string
    slug: string
    business_category?: string | null
    sample_list_query?: string | null
  }
}

export interface UserStatus {
  onboarding_completed: boolean
  has_active_org: boolean
  active_organization_id: string | null
  organizations: OrganizationMembership[]
}

export const profileApi = {
  getMe: async (): Promise<Profile> => {
    const response = await api.get('/v1/me/profile')
    return response.data
  },

  updateMe: async (payload: Partial<Profile>): Promise<Profile> => {
    const response = await api.put('/v1/me/profile', payload)
    return response.data
  },

  /**
   * Get unified status for routing decisions.
   * Consolidates profile + org membership status in a single call.
   */
  getStatus: async (): Promise<UserStatus> => {
    const response = await api.get('/v1/me/status')
    return response.data
  }
}
